export default __webpack_public_path__ + "static/contact-hero-img-ca021d3451ae426978b47c0e333922c5.png";